<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'mqttMessage',
})
</script>
<template>
<a-drawer v-model:open="opend"  @cancel="Cancel" width="40%">
    <a-list size="large"  :data-source="msgs" itemLayout="vertical">
    <template #renderItem="{ item }">
      <a-list-item>
        <div class="flex align-start text-right" v-if="uid==item.from">
          <div class="flex1">
            <p class="text-gray text-sm">{{ item.from }}</p>
            <p>{{ item.message }}</p>
          </div>
          <UserOutlined class="padding text-primary"style="font-size: 40px;"  />
        </div>
        <div class="flex align-start" v-else>
          <SmileOutlined class="padding text-red"style="font-size: 40px;" />
          <div class="flex1">
            <p class="text-gray text-sm">{{ item.from }}</p>
            <p>{{ item.message }}</p>
          </div>
        </div>
      </a-list-item>
    </template>
  </a-list>
  <template #title>
    <div class="flex align-center">
      <div class="flex1">
        <div>Lanseed 即时共享通信工具 v3 </div>
        <div class="text-sm text-gray">{{ defaultConfig.mqttServer }}提供通信服务</div>
      </div>
        <a-switch checked-children="已连接" un-checked-children="已断开" v-model:checked="connected" :disabled="true" />
    </div>

  </template>
  <template #footer>
      <div>
        <a-input-search
        placeholder="写点什么..."
        enter-button="发送"
        size="large"
        v-model:value="word"
        @search="Send"
      />
      </div>
    </template>
</a-drawer>
</template>
<script setup lang="ts" name="mqttMessage">
import mqtt from 'mqtt'
import {ref,defineProps, onMounted, reactive,defineEmits,watch,defineExpose} from 'vue'
import defaultConfig from '@/config/defaultSettings'
import {message, notification} from 'ant-design-vue'
import {SmileOutlined,UserOutlined} from '@ant-design/icons-vue'
const opend=ref<Boolean>(false)

let server=reactive<Object|null>(null)
let options = reactive<any>({
  username: defaultConfig.mqttUsername,
  password: defaultConfig.mqttPassword,
  clean: true, // true: 清除会话, false: 保留会话
  connectTimeout: 4000, // 超时时间
  clientId: ''
})
let basic_path='lanseed_vue3/'
let publish_topic=ref<String>('')
let subric_topic=ref<String>('')
let connected=ref<Boolean>(false)
let msgs=reactive<Array>([])
const uid=ref<String>('')
const word=ref<String>('')
const  Connect=():void=>{
  if(!defaultConfig.mqttServer){
    notification.error({message:'未配置通信服务器'})
    return false
  }
  server=mqtt.connect(defaultConfig.mqttServer,options)
  server.on('connect',()=>{
    server.subscribe(subric_topic.value, { qos: 1 })
    connected.value=true
  })
  server.on('error', (error: {}) => {
    connected.value=false
  })
  server.on('message', (topic: string, message: any) => {
    let ts=topic.split('/')
    msgs.push({toppic:topic,message:message,from:ts[ts.length-1]})
  })
}
const Cancel=():void=>{
  if(server){
    server.end()
    server=null
  }
  opend.value=false
}
const close=()=>{
  Cancel()
}
const Send=(msg):void=>{

  if(server){
    server.publish(publish_topic.value,msg,{ qos: 1 })
    word.value=''
  }
}
const open=(topic:String,userid:String)=>{
    uid.value=userid
    subric_topic.value=basic_path+topic+'/#'
    publish_topic.value=basic_path+topic+'/'+userid
    options.clientId='lanseed_vue3_'+userid
    opend.value=true
    if(server){
      server.end()
      server=null
      setTimeout(Connect,500)
    }else{
      Connect()
    }
}
defineExpose({
  open,close
})
</script>
